export default {"src":"/_next/static/media/callout-deprecated.abbb6dec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};